import useDeviceType from "hooks/useDeviceType";
import {  useGlassesStore } from "zus/glassesStore";
import AdditionalCampaignMessageComponent from "./AdditionalCampaignMessageComponent";
import { useMemo } from "react";
import { slugToString } from "functions/slug";
import { useRouter } from "next/router";
import { CategoryLensTypes } from "constants/dataTypes";
import { getMinPriceForLensType, getMinPriceLensItem } from "functions/filterLensTypes";
import { getProductPricingDescription, getProductPricingDescriptionFromLensType } from "functions/getProductPricingDescription";
import { useQueryState } from "nuqs";


export const ProductTitle = (
  { showOnMobile = false, categoryLensTypes, categorySlug, price }: { 
    showOnMobile?: boolean; 
    categoryLensTypes?: CategoryLensTypes[]; 
    categorySlug?: string;
    price?: number;
  }
) => {

  const deviceType = useDeviceType();
  const router = useRouter();

  const category = categorySlug ?? router.query.category as string;

  //check if router.query.product is prescription-sunglasses, prescription-glasses or reading-glasses
  const isPrescriptionLensZ = category == 'prescription-sunglasses' || category == 'prescription-glasses';

  const isSunglasses = category.toLowerCase().includes('sunglasses');


	const [armColorQuery] = useQueryState('armColor');
  const [lensColorQuery] = useQueryState('lensColor');

  //const armColor = armColorQuery ?? router.query.product;
  const lensColor = lensColorQuery ?? (isSunglasses ? 'grey' : 'clear');

  const lens_thickness_selected = router.query.lensThickness;
  
  const calculatedPrice = useMemo(() => {
    // Handle frames case
    if (category === 'frames') {
      return price ? `$${price}` : '';
    }

    // Handle lens cases
    if (categoryLensTypes) {
      if (lensColor.includes('mirror-')) {
        const mirrorLensPrice = getMinPriceForLensType(categoryLensTypes, 'mirror-');
        if (mirrorLensPrice) {
          return getProductPricingDescriptionFromLensType(mirrorLensPrice);
        }
      } else {
        const minPriceLensItem = getMinPriceLensItem(categoryLensTypes);
        if (minPriceLensItem) {
          return getProductPricingDescriptionFromLensType(minPriceLensItem);
        }
      }
    }
    return '';
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [category, lensColor, lens_thickness_selected]);
  
  
  if (deviceType.isMobile && showOnMobile) {
    return (
      <div className={`lg:hidden flex flex-col gap-4`}>
        <h1 className="font-sans font-bold text-black text-[20px] leading-[22px]">
          {slugToString(category)} - {slugToString(router.query.product as string)}
        </h1>
        
        <h5 className="text-[16px] leading-[18px] font-sans font-normal mb-4 text-black">
          <span dangerouslySetInnerHTML={{ __html: calculatedPrice }}></span>
          {isPrescriptionLensZ && (
            <span className="text-[#959595]">, including prescription lenses </span>

          )}
        </h5>

        
        
      </div>
    );
  }
  else if (deviceType.isDesktop && !showOnMobile) {
    return (
      <div className={`hidden lg:flex flex-col gap-4 mb-4`}>
        <h1 className="font-sans text-[28px] leading-[31px] font-bold">
          {slugToString(category)} - {slugToString(router.query.product as string)}
        </h1>
        <h5 className="text-[16px] leading-[18px] font-sans font-normal text-black">
          <span dangerouslySetInnerHTML={{ __html: calculatedPrice}}></span>
          {isPrescriptionLensZ && (
            <span className="text-[#959595]">, including prescription lenses </span>

          )}
        </h5>

        {/* <AdditionalCampaignMessageComponent /> */}
      </div>
    );
  }

  return null;

};